export enum CommonComponent {
  HrefLink = "shared.href-link",
  LinkList = "shared.link-list",
  SidebarMainNavigation = "shared.sidebar-main-navigation",
  SidebarOtherNavigation = "shared.sidebar-other-navigation",
  FooterCta = "shared.footer-cta",
  FooterContent = "shared.footer-content",
  Subtitle = "shared.subtitle",
  TextWithIcon = "shared.text-with-icon",
  BentoCard = "shared.bento-card",
  BentoGrid = "shared.bento-grid",
  EmptyScreen = "shared.empty-screen",
}

export type LinkTarget = "_blank" | "_self" | "_parent" | "_top" | string;

export type THrefLink = {
  id: number;
  text: string;
  href: string;
  description?: string;
  target: LinkTarget;
  icon?: IImage;
  color?: {
    code: string;
    label: string;
  };
  iconPosition?: "start" | "end";
  __component: CommonComponent.HrefLink;
};

export type TLinkList = {
  id: number;
  title: string;
  list: THrefLink[];
  __component: CommonComponent.LinkList;
};

export type NavigationItem = THrefLink | TLinkList;

export type SidebarMainNavigation = {
  id: number;
  list: THrefLink[];
  __component: CommonComponent.SidebarMainNavigation;
}

export type SidebarOtherNavigation = {
  id: number;
  title: string;
  list: THrefLink[];
  __component: CommonComponent.SidebarOtherNavigation;
}

export type SidebarNavigationItem = SidebarMainNavigation | SidebarOtherNavigation;

export type UserPopupNavigationItem = THrefLink | TLinkList;

export type FooterCta = {
  id: number;
  title: string;
  links: THrefLink[];
}

export type FooterContent = {
  id: number;
  title: string;
  description: string;
  socials: THrefLink[];
  contacts: TLinkList[];
}

export interface ImageAttributes {
  alternativeText?: string | null;
  url: string;
  width: number;
  height: number;
  name: string;
}

export type IImage = {
  id?: string;
} & ImageAttributes;

export type IImages = IImage[];

export type PageData<T> = {
  id: number;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
} & T;

export type TSEOMetaSocialItem = {
  description: string;
  id: number;
  image?: IImage | null;
  socialNetwork: string;
  title: string;
};

export type TSEOComponentData = {
  id: number;
  canonicalURL?: string;
  keywords?: string;
  metaDescription?: string;
  metaImage?: IImage | null;
  metaRobots?: string;
  metaSocial?: TSEOMetaSocialItem[];
  metaTitle?: string;
  metaViewport?: string;
};

export type TButtonLink = THrefLink;

export type FormFieldType = "string" | "number" | "bigint" | "boolean";
export type FormInputType = "email" | "text" | "tel" | "number" | "textarea" | "radio";

export type TFormField = {
  id: string;
  label: string;
  placeholder: string;
  type: FormFieldType;
  validations?: string;
  optional: boolean;
  name: string;
  inputType: FormInputType;
  options?: string[];
};

export type TFooterCta = {
  id: number;
  title: string;
  links: THrefLink[];
  __component: CommonComponent.FooterCta;
}

/**
 * Country code according to {@link https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements ISO 3166}
 */
export enum CountryCode {
  ID = "ID",
}

export enum Locale {
  en = "en",
  idID = "id-ID",
}

export type TSubtitle = {
  id: number;
  title: string;
  icon?: IImage;
}

export type TTextWithIcon = {
  id: number;
  title: string;
  icon: IImage;
  description: string;
}

export type BentoCardVariant = "default" | "primary";
export type BentoCardImagePosition = "bottom" | "right";
export type TBentoCard = {
  id: number;
  title: string;
  description?: string;
  subtitle?: TSubtitle;
  image?: IImage;
  variant: BentoCardVariant;
  imagePosition: BentoCardImagePosition;
  backgroundImage?: IImage;
  button?: THrefLink;
  className?: string;
  imageClassName?: string;
}

export type TTestimony = {
  id: number;
  name: string;
  jobPosition: string;
  testimony: string;
  avatar?: IImage;
}

export type TBentoGrid = {
  id: number;
  colSize: "one" | "two";
  cards: TBentoCard[];
}

export type TEmptyScreen = {
  id: number;
  title: string;
  description: string;
  __component: CommonComponent.EmptyScreen;
}